import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { ButtonComponent } from "../ButtonComponent";
import WorkLogReport from "../../models/WorkLogReport";
import { sendSnackBarMessage } from "../../utils/SnackBarUtils";
import { SnackBarData } from "../../external/ensolvers-core-frontend-mui/types/SnackbarData";
import { Spinner } from "../../external/ensolvers-core-frontend-mui/components/Common/Spinner";

const options = ["Adjust hours", "Apply fixed hours"];

export interface AdjustHoursButtonsProps {
  worklogReportState: any;
  worklogs: WorkLogReport[];
  processing: boolean;
}
export default function BatchHoursAdjustmentButton(props: AdjustHoursButtonsProps) {
  const handleClick = () => {
    if (!props.worklogs.length) return;
    props.worklogReportState.setBatchReportsToAdjust(props.worklogs);
  };

  return (
    <div style={{ height: "1.7rem", display: "flex", alignItems: "center" }}>
      <ButtonComponent
        disabled={!props.worklogs.length || props.processing}
        debounce={true}
        onClick={handleClick}
        text="Adjust hours"
        style={{
          margin: "0%",
          height: "100%",
          padding: "0.75rem",
          borderRadius: "1.375rem",
          minWidth: "5rem",
        }}
      />
      <div style={{ margin: "0 10px" }}>{props.processing && <Spinner size={20} />}</div>
    </div>
  );
}
